export class PromptModel {
    id: number;
    title: string;
    prompt: string;

    constructor(id: number, title: string, prompt: string) {
        this.id = id;
        this.title = title;
        this.prompt = prompt;
    }
}